import styled from "styled-components";
import { BREAKPOINTS } from "@onelogin/react-components";

const ScreenWrapper = styled.div`
  height: 100%;
  width: 100%;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media screen and (max-width: ${BREAKPOINTS.PHONE_LARGE}) {
    margin-bottom: 0;
  }
`;

export default ScreenWrapper;
